import $ from 'jquery';

import TooltipHelper from 'chairisher/view/helper/tooltip';

import { isTouchDevice } from 'chairisher/util/mediaquery';

/**
 * Client-side rendering of doesShipToYou
 */
const DoesShipToYou = {
    /**
     * Adds the edit my location link to navigate to the shipping options section and expand the section
     */
    addEditMyLocationAnimation() {
        // Opens Info Shipping Section and Navigates To It
        $('.js-edit-my-location-link').on('click', (e) => {
            e.preventDefault();
            const $shippingInfo = $('#js-info-shipping');
            $shippingInfo.collapse('show');
            $shippingInfo.get(0).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        });
    },

    /**
     * Adds the tooltips for the doesShipToYou information icons
     */
    addOnlyShipsToTooltips() {
        // Apply Tooltip To Product Meta Location Icon
        const $productMetaOnlyShipsTo = $('.product-meta .js-only-ships-to');
        if (isTouchDevice()) {
            $productMetaOnlyShipsTo.on('click', (e) => {
                e.preventDefault();
                $productMetaOnlyShipsTo.tooltip({ placement: TooltipHelper.getPlacement });
                $productMetaOnlyShipsTo.tooltip('toggle');
            });
        } else {
            $productMetaOnlyShipsTo.tooltip({ placement: TooltipHelper.getPlacement });
        }

        // Apply Tooltip To Shipping Info Location Icon
        const $shippingInfoOnlyShipsTo = $('#js-info-shipping .js-only-ships-to');
        if (isTouchDevice()) {
            $shippingInfoOnlyShipsTo.on('click', (e) => {
                e.preventDefault();
                $shippingInfoOnlyShipsTo.tooltip({ placement: TooltipHelper.getPlacement });
                $shippingInfoOnlyShipsTo.tooltip('toggle');
            });
        } else {
            $shippingInfoOnlyShipsTo.tooltip({ placement: TooltipHelper.getPlacement });
        }
    },

    /**
     * Renders the proper UI on the pdp for the instance where the item does not ship to the user
     */
    showDoesNotShipToYouElementsOnPdp(restrictedShippingDisclaimer) {
        // Hide Skeleton
        $('.js-skeleton-loading-field').addClass('hidden');

        // Update text and expose Does Not Ship To You UI
        $('.js-does-not-ship-to-location-message').text(restrictedShippingDisclaimer.display);
        $('.js-product-does-not-ship-to-location').removeClass('hidden');
    },

    /**
     * Renders the proper UI on the pdp for the instance where the item does ship to the user
     */
    showShipsToYouElementsOnPdp(productData) {
        // Hide Loading Skeleton
        $('.js-skeleton-loading-field').addClass('hidden');

        // Update text and expose Estimated Delivery
        const estimatedArrivalDisplayParts =
            productData.meta &&
            productData.meta.estimated_arrival &&
            productData.meta.estimated_arrival.display &&
            productData.meta.estimated_arrival.display.split(': ');
        if (estimatedArrivalDisplayParts.length > 1) {
            $('.js-product-ships-from').addClass('colon-after');
            $('.js-arrival-info-link').removeClass('hidden').text(estimatedArrivalDisplayParts[1]);

            const $arrivalInfoTooltip = $('.js-arrival-info-tooltip');
            if ($arrivalInfoTooltip.length) {
                $arrivalInfoTooltip.removeClass('hidden').tooltip({ placement: TooltipHelper.getPlacement });
            }
        }
        $('.js-product-estimated-arrival').removeClass('hidden');

        // Expose Shipping Options
        $('#js-shipping-partner-codes').removeClass('hidden');
    },

    /**
     * Evaluates product data for a given product and returns restricted shipping disclaimer
     *
     * @param {Object} data Contains the product data for a given product
     * @returns {Object|undefined} Restricted shipping disclaimer
     */
    restrictedShippingDisclaimer(data) {
        return data.meta && data.meta.disclaimers
            ? data.meta.disclaimers.find((disclaimer) => disclaimer.code === 'RESTRICTED_SHIPPING')
            : undefined;
    },

    /**
     * Hides the item doesNotShipToYou help messaging
     */
    hideDoesShipToMeMessaging() {
        // Hide Does Not Ship To You UI
        $('.js-product-does-not-ship-to-location').addClass('hidden');
    },

    /**
     * Hides the shipping options and displays the doesNotShipToYou messaging
     */
    hideShippingOptions() {
        // Hide Estimated Delivery
        $('.js-product-estimated-arrival').addClass('hidden');

        // Hide Shipping Options
        $('#js-shipping-partner-codes').addClass('hidden');

        // Expose Does Not Ship To You UI
        $('.js-product-does-not-ship-to-location').removeClass('hidden');
    },

    /**
     * The rendering "engine", takes product's meta data passed in and renders them on the PDP.
     *
     * @param {Object} productData product data Object
     *      e.g. - { meta: {...} }
     */
    renderDoesShipToYouOnPdp(productData) {
        const restrictedShippingDisclaimer = this.restrictedShippingDisclaimer(productData);

        if (restrictedShippingDisclaimer) {
            this.showDoesNotShipToYouElementsOnPdp(restrictedShippingDisclaimer);
        } else {
            this.showShipsToYouElementsOnPdp(productData);
        }

        this.addOnlyShipsToTooltips();
        this.addEditMyLocationAnimation();
    },

    /**
     * Hides the doesNotShipToYou messaging and shows the shipping options
     */
    showShippingOptions() {
        // Expose Estimated Delivery
        $('.js-product-estimated-arrival').removeClass('hidden');

        // Expose Shipping Options
        $('#js-shipping-partner-codes').removeClass('hidden');

        // Hide Does Not Ship To You UI
        $('.js-product-does-not-ship-to-location').addClass('hidden');
    },
};

export default DoesShipToYou;
